import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import EStores from "../../enums/EStores.ts";
import {IAdSpace} from "../../interfaces/IAd.ts";
import {EAdOrientation} from "../../enums/EAdOrientation.ts";

export interface IAdvertising {
  top: IAdSpace[];
  right: IAdSpace[];
  bottom: IAdSpace[];
}

const initialState: IAdvertising = {
  top: [],
  right: [],
  bottom: [],
}

const slice = createSlice({
  name: EStores.ADVERTISING,
  initialState,
  reducers: {
    setAds(state, action: PayloadAction<IAdSpace[]>) {
      const ads = action.payload;

      const horizontalAds = ads.filter(ad => ad.orientation === EAdOrientation.HORIZONTAL);
      const verticalAds = ads.filter(ad => ad.orientation === EAdOrientation.VERTICAL);

      state.top = horizontalAds.slice(0, 2);
      state.bottom = horizontalAds.slice(2, 4);
      state.right = verticalAds;
    },
    clearAds(state) {
      state.top = [];
      state.right = [];
      state.bottom = [];
    },
  },
});

export const {
  setAds,
  clearAds,
} = slice.actions;

export default slice.reducer;
